import { gql } from '@apollo/client';

export const insertSms = gql`
  mutation insertSms($data: [sms_insert_input!]!) {
    sms: insert_sms(objects: $data) {
      affected_rows
    }
  }
`;
